import type { ReactNode } from 'react';

export const symbol_integration_instructions: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m326-480 80-80q9-9 9-21.5t-8.61-21.5q-9.39-9-21.89-9t-21.5 9L261-501q-9 9-9 21t9 21l102 102q9 9 21.5 9t21.89-9q8.61-9 8.61-21t-9-21l-80-81Zm309 0-81 81q-9 9-9 21t8.61 21q9.39 9 21.89 9t21.5-9l103-102q9-9 9-21t-9-21L598-603q-9-9-21-9t-21.39 9q-8.61 9-8.61 21.5t9 21.5l79 80ZM180-120q-24.75 0-42.37-17.63Q120-155.25 120-180v-600q0-24.75 17.63-42.38Q155.25-840 180-840h205q5-35 32-57.5t63-22.5q36 0 63 22.5t32 57.5h205q24.75 0 42.38 17.62Q840-804.75 840-780v600q0 24.75-17.62 42.37Q804.75-120 780-120H180Zm0-60h600v-600H180v600Zm324.5-627.5Q515-818 515-832t-10.5-24.5Q494-867 480-867t-24.5 10.5Q445-846 445-832t10.5 24.5Q466-797 480-797t24.5-10.5ZM180-180v-600 600Z"
		/>
	</svg>
);
